import FullWidthLayout from "@/layouts/FullWidthLayout";
import KServiceMap from "@/components/Front/KService/KServiceMap";
import { Pageable } from "kinnect-mixins";

export default {
	name: "ServicesPage",

	metaInfo: { title: "Service Map" },

	mixins: [ Pageable ],

	computed: {
		toolbarActions() {
			if ( this.$can( "add_services" ) ) {
				return {
					icon: "add_circle",
					text: "Add Service",
					to: { name: "serviceAdd" },
					tooltip: "Add a service entry"
				};
			}
		}
	},

	render() {
		return <FullWidthLayout>
			<KServiceMap></KServiceMap>
		</FullWidthLayout>;
	}
};
